import {InstantlyService} from '../../libs/ui/src/index';

import {client} from '../apiService';
const _InstantlyService = new InstantlyService({client});
export {_InstantlyService as InstantlyService};
